export default {
      id: "search-alt-usage",
      viewBox: "0 0 17 17",
      url: "/assets/" + "icons.svg#search-alt",
      toString: function () {
        return this.url;
      }
    }